const MINUTE = 60 * 1000;

export const CacheTimes = {
  limit10m: 10 * MINUTE,
  limit10s: 10 * 1000,
  limit60s: MINUTE,
};

export const RefreshTimes = {
  every15s: 15 * 1000,
  every30s: 30 * 1000,
  every5min: 5 * 60 * 1000,
};

export const PageSizes = {
  episodesList: 20,
};

export const nullResponse = {
  getContent: () => undefined,
  module: undefined,
};
